import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Download } from 'lucide-react';
import BookingComponent from '../components/BookingComponent';
import SeoMeta from '../components/SeoMeta';

const BOOKING_TOKEN = '2719ff77-7a99-47a7-b9cd-8a32161ef920';


const MeetingPage = () => {
  const [searchParams] = useSearchParams();
  const locale = searchParams.get('lang') || 'es';
  const prefillName = searchParams.get('name') || '';
  const prefillEmail = searchParams.get('email') || '';
  const prefillSubject = searchParams.get('subject') || '';
  const isSpanish = locale === 'es';
  const [bookingConfirmed, setBookingConfirmed] = useState(false);

  // Detectar perfil desde subject (e.g. "Wizard: shipper / 500-2500")

  const displayName = prefillName || (prefillEmail ? prefillEmail.split('@')[0].split('.').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') : '');

  return (
    <>
      <SeoMeta
        title={isSpanish ? 'Reserva tu reunión con BlueCMR' : 'Book a meeting with BlueCMR'}
        description={isSpanish ? 'Selecciona fecha y hora. El equipo de BlueCMR te enviará el enlace de la reunión.' : 'Select a date and time. The BlueCMR team will send you the meeting link.'}
        noindex
      />
      <div className="min-h-[60vh] py-12 px-4">
        <div className="max-w-2xl mx-auto text-center mb-8">
          <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3">
            {displayName
              ? (isSpanish ? `Hola ${displayName}, reserva tu reunión` : `Hi ${displayName}, book your meeting`)
              : (isSpanish ? 'Reserva tu reunión con BlueCMR' : 'Book a meeting with BlueCMR')}
          </h1>
          <p className="text-gray-600 leading-relaxed">
            {prefillEmail
              ? (isSpanish
                  ? 'Elige fecha y hora. Te enviaremos la invitación con el enlace de la reunión.'
                  : 'Select the date and time that works best for you. We will send you the meeting invite.')
              : (isSpanish
                  ? 'Elige fecha y hora. Te enviaremos la invitación con el enlace de la reunión.'
                  : 'Select the date and time that works best for you. The BlueCMR team will review your request and send you a calendar invite with the meeting link.')}
          </p>
        </div>
        <div className="flex justify-center">
          <BookingComponent bookingToken={BOOKING_TOKEN} locale={locale} prefillName={prefillName} prefillEmail={prefillEmail} prefillSubject={prefillSubject} onBookingConfirmed={() => setBookingConfirmed(true)} />
        </div>

      </div>
    </>
  );
};

export default MeetingPage;
